interface HotelOffer {
  id: string;
  name: string;
  stars: number;
  rating: number;
  pricePerNight: number;
  totalPrice: number;
  currency: string;
  address: string;
  imageUrl?: string;
  bookingUrl: string;
}

interface HotelCardProps {
  hotel: HotelOffer;
}

export function HotelCard({ hotel }: HotelCardProps) {
  return (
    <div className="frost-card rounded-lg p-3 text-sm text-ink">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-medium truncate">{hotel.name}</span>
            {hotel.stars > 0 && (
              <span className="text-xs text-warm shrink-0">
                {"*".repeat(hotel.stars)}
              </span>
            )}
          </div>
          {hotel.address && (
            <p className="text-xs text-ink-light mt-0.5 truncate">
              {hotel.address}
            </p>
          )}
          {hotel.rating > 0 && (
            <span className="text-xs text-ink-light">
              Rating: {hotel.rating}/10
            </span>
          )}
        </div>
        <div className="text-right shrink-0 ml-3">
          <p className="font-bold text-warm">
            {hotel.currency} {hotel.pricePerNight?.toFixed(0)}
          </p>
          <p className="text-xs text-ink-light">per night</p>
        </div>
      </div>
      {hotel.bookingUrl && (
        <a
          href={hotel.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 inline-block text-xs text-accent-light hover:text-accent hover:underline font-medium"
        >
          View on Booking
        </a>
      )}
    </div>
  );
}
